import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=fcc3ac22&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"
import style0 from "./Loading.vue?vue&type=style&index=0&id=fcc3ac22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc3ac22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcc3ac22')) {
      api.createRecord('fcc3ac22', component.options)
    } else {
      api.reload('fcc3ac22', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=fcc3ac22&scoped=true", function () {
      api.rerender('fcc3ac22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/Loading.vue"
export default component.exports